import { listCross } from './listCross'
import { webKnots } from '../../../../common/back/lace/webKnots'

export const laceOfWristBeltCrossDrawer = (ctx: CanvasRenderingContext2D, color: string, productNumber: string): void => {
  switch (productNumber) {
    case 'BKN-20':
      listCross(ctx, color, 22, -10) // 手口左のクロス部分
      webKnots(ctx, color, -115, 340, 13, 0.8) // 手首ベルト左の結び目
      webKnots(ctx, color, -250, 300, 10, 0.8) // 独立パーツと指パーツとの接合部分
      break
    default:
      listCross(ctx, color, 0, 0) // 手口左のクロス部分
      webKnots(ctx, color, -170, 400, 10, 0.8) // 手首ベルト左の結び目
      break
  }
}
